<template>
  <div class="popup-down">
    <div class="popup_wrap">
      <h1 class="popup_title">Statements</h1>
      <div class="popup_inner">
        <div class="short_contact">
          <dl class="address">
            <dt>{{ $t(`${siteCode}_지점명칭`) }}</dt>
            <dd v-html="$t(`${siteCode}_지점주소`)"></dd>
          </dl>
          <dl>
            <dt>{{ /*전화번호*/ $t("MINQ-02-03-03-17") }} :</dt>
            <dd>{{ $t(`지점별전화번호_${siteCode}`) }}</dd>
          </dl>
          <!-- <dl>
            <dt>Fax No. :</dt>
            <dd>+64 9 366 6608</dd>
          </dl>-->
          <dl>
            <dt>Email :</dt>
            <dd>{{ $t(`이메일_${siteCode}`) }}</dd>
          </dl>
          <dl v-if="siteCode == $config.SITECODE_OGAUC">
            <dt>{{ /* SWIFT CODE */ $t("P018-019")}} :</dt>
            <dd>{{ $t("P018-112") }}</dd>
          </dl>
        </div>

        <div class="wrap_title">
          <p class="fr txt_now">
            {{ /*조회기간*/ $t("MINQ-02-03-03-05") }} :
            <span>{{ $getGlobalDateFmt(inquryYmd) }}</span>
          </p>
        </div>
        <div class="wrap_table hori pl0">
          <table>
            <thead>
              <tr>
                <th scope="col">{{ /*계좌명*/ $t("MINQ-02-03-03-18") }}</th>
                <th scope="col">{{ /*계좌번호*/ $t("MINQ-02-03-03-19") }}</th>
                <th scope="col">{{ /*통화*/ $t("MINQ-02-03-03-20") }}</th>
                <th scope="col">{{ /*만기일*/ $t("MINQ-02-03-03-21") }}</th>
                <th scope="col">{{ /*해지일*/ $t("MINQ-02-03-03-22") }}</th>
                <th scope="col">{{ /*전월잔액*/ $t("MINQ-02-03-03-23") }}</th>
                <th scope="col">{{ /*당월잔액*/ $t("MINQ-02-03-03-24") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list3, k) in RBF0404D40.header" :key="k">
                <td>{{ list3.prdctOcntryName }}</td>
                <td>{{ list3.acno }}</td>
                <td>{{ list3.cncycd }}</td>
                <td>{{ $getGlobalDateFmt(list3.expirYmd) }}</td>
                <td>{{ $getGlobalDateFmt(list3.termiYmd) }}</td>
                <td class="txt_right num">{{ $num(list3.openingBal) }}</td>
                <td class="txt_right num">{{ $num(list3.dpostBal) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="RBF0404D40.totalLineCnt2 > 0">
          <div v-for="(list1, i) in uniqueAcno" :key="i">
            <div class="wrap_title">
              <h2 class="h_title4 fl fc_point1">{{ list1.acno }}</h2>
            </div>
            <div class="wrap_table hori">
              <table>
                <colgroup>
                  <col width="15%" />
                  <col v-if="siteCode != $config.SITECODE_OGAUC" width="10%" />
                  <col width="20%" />
                  <col width="10%" />
                  <col width="15%" />
                  <col width="15%" />
                  <col width="15%" />
                  <col v-if="siteCode == $config.SITECODE_OGAUC" width="10%" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">{{ /*거래일*/ $t("MINQ-02-03-03-25") }}</th>
                    <th scope="col" v-if="siteCode != $config.SITECODE_OGAUC">
                      <template v-if="siteCode == $config.SITECODE_OGIND">type</template>
                      <template v-else>{{ /*송금메모*/ $t("MINQ-02-03-03-26") }}</template>
                    </th>
                    <th scope="col">{{ /*적요*/ $t("MINQ-02-03-03-27") }}</th>
                    <th scope="col">{{ /*통화*/ $t("MINQ-02-03-03-28") }}</th>
                    <th scope="col">{{ /*입금액*/ $t("MINQ-02-03-03-29") }}</th>
                    <th scope="col">{{ /*출금액*/ $t("MINQ-02-03-03-30") }}</th>
                    <th scope="col">{{ /*잔액*/ $t("MINQ-02-03-03-31") }}</th>
                    <th scope="col" v-if="siteCode == $config.SITECODE_OGAUC">
                      <template>type</template>
                    </th>
                  </tr>
                </thead>
                <template v-for="(list2, j) in historyList">
                  <tr v-if="list1.acno == list2.data.acno" :key="j">
                    <td>{{ /*거래년월일*/ $getGlobalDateFmt(list2.data.tranYmd) }}</td>
                    <td
                      v-if="siteCode != $config.SITECODE_OGAUC"
                    >{{ /*적요표기내용(근거)*/ list2.data.sumryNotnCtnt }}</td>
                    <td class="wsNor">{{ /*적요내용*/ list2.data.sumryCtnt }}</td>
                    <td>{{ /*통화코드*/ list2.data.cncycd }}</td>
                    <td class="txt_right num">{{ /*입금금액*/ $num(list2.data.deposits) }}</td>
                    <td class="txt_right num">{{ /*출금금액*/ $num(list2.data.withdrawals) }}</td>
                    <td class="txt_right num">{{ /*거래후예금잔액*/ $num(list2.data.tranAfDpostBal) }}</td>
                    <td
                      v-if="siteCode == $config.SITECODE_OGAUC"
                    >{{ /*적요표기내용(근거)*/ list2.data.sumryNotnCtnt }}</td>
                  </tr>
                </template>
              </table>
            </div>
          </div>
          <ul class="list txt">
            <li>{{ /*본 화면은 고객편의를 위하여 제공되는 것으로 법적효력이 없습니다.*/ $t("MINQ-02-03-03-32") }}</li>
          </ul>
          <div class="wrap_cont cont_info type1" v-if="RBF0404D40.synopsisList.length > 0">
            <h2 class="ex_title" style="margin-top:0">{{ /*적요*/ $t("MINQ-02-03-03-27") }}</h2>
            <dl class="explain type2" v-for="(list3, k) in RBF0404D40.synopsisList" :key="k">
              <dt>{{ list3.sumryNotnCtnt }}</dt>
              <dd>{{ list3.sumryCtnt }}</dd>
            </dl>
          </div>
        </div>
        <div class="wrap_table hori" v-else>
          <table>
            <tr>
              <td class="none">{{ /*조회 내역이 없습니다.*/ $t("MCOM-0000015") }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields("accounts/statementInq", ["RBF0404D40", "historyList", "uniqueAcno", "inquryYmd"]),
    ...mapFields(["lang", "siteCode"]),
  },
};
</script>
